module.exports = __webpack_public_path__ + "img/tutorial_query-search.3bc6640e.png";